/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Status_In_ProgressInputs */

const vi_work_activity_status_in_progress = /** @type {(inputs: Work_Activity_Status_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang làm`)
};

/**

* @param {Work_Activity_Status_In_ProgressInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_status_in_progress = /** @type {((inputs?: Work_Activity_Status_In_ProgressInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Status_In_ProgressInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_status_in_progress(inputs)
});